import { render, staticRenderFns } from "./ObjectFeatures.vue?vue&type=template&id=bd268ef8&scoped=true"
import script from "./ObjectFeatures.vue?vue&type=script&lang=js"
export * from "./ObjectFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd268ef8",
  null
  
)

export default component.exports